import React, {useState} from "react";
import logoIconWhite from "../../assets/images/icons/logo_icon_white.svg";
import {goVehisService} from "../../utils/axios";

function HomeNewsletter() {
    const [email, setEmail] = useState("");
    const [consent, setConsent] = useState(false);
    const [status, setStatus] = useState(null);
    const [errors, setErrors] = useState({});

    const handleSubmit = async () => {
        const newErrors = {};
        if (!email) {
            newErrors.email = "Podaj adres e-mail.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = "Nieprawidłowy format e-mail.";
        }
        if (!consent) {
            newErrors.consent = "Zaznacz zgodę na politykę prywatności.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setErrors({});
        try {
            await goVehisService.post("/contact-agreements", {
                email,
                sourceUrl: window.location.href,
                source: "GO_AUTO",
                newsletterConsent: true,
            });
            setStatus("success");
            setEmail("");
            setConsent(false);
        } catch (e) {
            setStatus("error");
        }
    };

    return (
        <section className="home-newsletter-section">
            <div className="container">
                <div className="home-newsletter-inner">
                    <div className="home-newsletter-text">
                        <h2 className="home-newsletter-heading">Newsletter GO-auto</h2>
                        <p className="home-newsletter-desc">
                            Chcesz być na bieżąco ze światem leasingu? Zyskaj dostęp do specjalistycznej
                            wiedzy i ofert przed innymi! Zapisz się do naszego newslettera, aby otrzymać
                            informację o najnowszych treściach – bez zbędnych reklam i spamu.
                        </p>
                    </div>
                    <div className="home-newsletter-form">
                        <div className="home-newsletter-field">
                            <label className="home-newsletter-label">Adres e-mail</label>
                            <input
                                type="email"
                                className="home-newsletter-input"
                                value={email}
                                onChange={(e) => { setEmail(e.target.value); setErrors(prev => ({...prev, email: undefined})); }}
                            />
                            {errors.email && <p className="home-newsletter-error">{errors.email}</p>}
                        </div>
                        <div className="search-checkbox-row">
                            <input
                                type="checkbox"
                                id="newsletter-consent"
                                checked={consent}
                                onChange={(e) => { setConsent(e.target.checked); setErrors(prev => ({...prev, consent: undefined})); }}
                            />
                            <label htmlFor="newsletter-consent">
                                Akceptuję{" "}
                                <a href="/rodo" className="home-newsletter-link">Politykę prywatności</a>
                            </label>
                        </div>
                        {errors.consent && <p className="home-newsletter-error">{errors.consent}</p>}
                        {status === "success" && (
                            <p className="home-newsletter-success">Dziękujemy za zapisanie się do newslettera!</p>
                        )}
                        {status === "error" && (
                            <p className="home-newsletter-error">Wystąpił błąd. Spróbuj ponownie później.</p>
                        )}
                        <button
                            type="button"
                            className="home-newsletter-btn"
                            onClick={handleSubmit}
                        >
                            ZAPISZ DO NEWSLETTERA
                            <img src={logoIconWhite} alt="" className="search-btn-icon"/>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HomeNewsletter;
